export default __webpack_public_path__ + "static/media/step2.717e3da5.webm";